import { cn, getUserImgSrc } from '#app/utils/misc.tsx'
import {
	getUserAvatarColorClass,
	getUserInitials,
} from '#app/utils/user-display.ts'

export function UserAvatar({
	userId,
	imageId,
	name,
	username,
	className,
}: {
	userId: string
	imageId?: string | null
	name?: string | null
	username: string
	className?: string
}) {
	const displayName = name ?? username

	if (imageId) {
		return (
			<img
				src={getUserImgSrc(imageId)}
				alt={displayName}
				className={cn('rounded-full object-cover', className)}
			/>
		)
	}

	return (
		<div
			className={cn(
				'flex shrink-0 items-center justify-center rounded-full font-semibold',
				getUserAvatarColorClass(userId),
				className,
			)}
			aria-hidden
		>
			{getUserInitials(name, username)}
		</div>
	)
}
